// extracted by mini-css-extract-plugin
module.exports = {"root":"_4cardsrow-module--root--jCNrL","wrapper":"_4cardsrow-module--wrapper--8rrD1","card":"_4cardsrow-module--card--3fQ0V"};